import React from 'react'
import {useHistory} from "react-router";

import {IonButton, IonButtons, IonIcon, IonItem, IonLabel} from "@ionic/react"

import {useDataSources as useItems}  from '../../contexts/DataSourceContext'

import {DataSource as ItemType}     from "../../types/DataSource"

import IconDataSource from "../common/Icons/DataSource";
import {repeatOutline, repeatSharp} from "ionicons/icons";
import ListItemButtonIsEnabled from "../common/Buttons/ListItemButtonIsEnabled";

interface itemProps {
    item: ItemType
}

const ListItem: React.FC<itemProps> = ({ item }) => {

    const { toggleItem } = useItems();

    const history = useHistory()
    const dataSourceSyncsCount: number = item.dataSourceSyncs?.length || 0

    const goToSegment = (ev: any, segment: string) => {
        ev.preventDefault()
        ev.stopPropagation()

        history.push('/data-sources/' + item.id + '/' + segment)
    }

    return (
        <>
            <IonItem button detail routerLink={"/data-sources/" + item.id + '/view'} slot="start">
                <IconDataSource slot="start" />
                <IonLabel>
                    {item.name}
                    <p>{item.dataSourceType?.name}</p>
                </IonLabel>
                <IonButtons className="ion-hide-sm-down" slot="end">
                    <div style={{ 'minWidth': '80px' }}>
                        <IonButton color="medium" fill="clear"
                                   onClick={ (ev) => goToSegment(ev, 'data-source-syncs') }
                                   shape="round" size="large" style={{ 'fontSize': '1rem' }}>
                            <IonIcon slot="start" color="bc-blue" ios={repeatOutline} md={repeatSharp} />
                            {dataSourceSyncsCount ? dataSourceSyncsCount : '-'}
                        </IonButton>
                    </div>
                    <ListItemButtonIsEnabled item={item} toggle={toggleItem} />
                </IonButtons>
            </IonItem>
        </>
    )
}

export default ListItem